"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconCommunication = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 18 18",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M18,0 L0,0 L0,18 L3.6,14.4 L18,14.4 L18,0 Z M16.2,12.6 L3.6,12.6 L1.8,14.4 L1.8,1.8 L16.2,1.8 L16.2,12.6 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconCommunication')(IconCommunication);